const cards = {
    svg: '<svg xmlns:xlink="http://www.w3.org/1999/xlink" style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path id="path-1" d="M7 1v6H1V1zM5.5 2.5h-3v3h3zM7 9v6H1V9zm-1.5 1.5h-3v3h3zM15 1v6H9V1zm-1.5 1.5h-3v3h3zM15 9v6H9V9zm-1.5 1.5h-3v3h3z"/></svg>',
};

export { cards as default };
